import { Link } from "react-router-dom";
import { ArrowRight, Leaf, Heart, Users } from "lucide-react";

const features = [
  { icon: Leaf, title: "Growth", text: "Transform challenges into stepping stones for personal development." },
  { icon: Heart, title: "Wellness", text: "Holistic approaches to mental health and emotional balance." },
  { icon: Users, title: "Community", text: "A supportive network of women professionals in STEM and beyond." },
];

const AboutTeaser = () => {
  return (
    <section
      id="about-teaser"
      data-testid="about-teaser-section"
      className="py-24 md:py-32 relative overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Image */}
          <div className="relative">
            <img
              src="https://images.unsplash.com/photo-1631676173149-ebe52fee3eb3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwyfHx3b21hbiUyMG1lZGl0YXRpbmclMjBuYXR1cmUlMjB3YXJtJTIwbGlnaHR8ZW58MHx8fHwxNzc2NzY5ODUzfDA&ixlib=rb-4.1.0&q=85"
              alt="Woman meditating peacefully in nature – holistic burnout recovery and mental wellness by The Lemonade Living Company"
              className="rounded-2xl w-full h-[400px] lg:h-[500px] object-cover"
            />
            <div
              className="absolute -bottom-6 -right-6 w-32 h-32 rounded-2xl"
              style={{ background: "var(--ll-accent)", opacity: 0.2 }}
            />
          </div>

          {/* Content */}
          <div>
            <p
              className="text-xs tracking-[0.3em] uppercase mb-4"
              style={{ color: "var(--ll-text-muted)", fontFamily: "'Outfit', sans-serif" }}
            >
              Our Philosophy
            </p>
            <h2
              className="font-serif text-3xl sm:text-4xl lg:text-5xl font-light mb-6"
              style={{ color: "var(--ll-text)" }}
            >
              Just as lemons become{" "}
              <em className="italic" style={{ color: "var(--ll-text-secondary)" }}>
                lemonade
              </em>
            </h2>
            <p
              className="text-base leading-relaxed mb-10"
              style={{ color: "var(--ll-text-secondary)", fontFamily: "'Outfit', sans-serif" }}
            >
              Life's hardest moments can become your greatest turning points. We believe in
              transformation through resilience, and we're building a community that supports
              mental wellness, personal growth, and positive impact.
            </p>

            <div className="space-y-6 mb-10">
              {features.map((f) => {
                const Icon = f.icon;
                return (
                  <div key={f.title} className="flex items-start gap-4">
                    <div
                      className="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0"
                      style={{ background: "var(--ll-bg-secondary)" }}
                    >
                      <Icon size={18} style={{ color: "var(--ll-green)" }} />
                    </div>
                    <div>
                      <p className="text-sm font-medium mb-1" style={{ color: "var(--ll-text)", fontFamily: "'Outfit', sans-serif" }}>
                        {f.title}
                      </p>
                      <p className="text-sm" style={{ color: "var(--ll-text-muted)", fontFamily: "'Outfit', sans-serif" }}>
                        {f.text}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>

            <Link
              to="/about"
              data-testid="about-learn-more"
              className="inline-flex items-center gap-2 rounded-full px-8 py-3.5 text-sm font-medium border transition-all duration-300 hover:-translate-y-0.5"
              style={{
                borderColor: "var(--ll-border)",
                color: "var(--ll-text-secondary)",
                fontFamily: "'Outfit', sans-serif",
              }}
            >
              Learn More About Us <ArrowRight size={14} />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutTeaser;
